import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardHeader, CardBody } from "reactstrap";
import SessionContext from "SessionContext";
import ProgressLoader from "partials/progress-loader";
import AuthTokenContext from "AuthTokenContext";

const _DATA = {
  "report_name": "Not Found",
  "report_description": "",
  "created_by": "",
  "variables": [],
  "groups": [
    {
      "name": "",
      "label": "",
      "values": []
    }
  ]
}


export default function CompareReportDetails({ args: { id } }) {
  const session = useContext(SessionContext);
  const tokens = useContext(AuthTokenContext);

  const [allData, setAllData] = useState();
  const [data, setData] = useState(_DATA);
  const [hasBadData, setHasBadData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fileName, setFileName] = useState("Comparison_Report.xlsx");

  const handleDownload = () => {
    fetch(`${window.api_url}/query/compare/download/${id}`, {
      headers: {
        "X-Active-Company": `${session.appState.activeCompany.id}`,
        Authorization: `Bearer ${tokens.accessToken}`,
      },
    }).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        url = encodeURI(url);
        let a = document.createElement("a");
        a.href = decodeURI(url);
        a.download = fileName;
        a.click();
      });
    });
  }

  useEffect(() => {
    if(allData) {
      const api_date = allData.comparison_report.created_date;
      const api_name = allData.comparison_report.name;
      const d = new Date(api_date);
      const formatted_date = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
      const formatted_name = api_name.trim().replace(/\s+/g, '_');
      const file_name = `Comparison_Report_${formatted_name}_${formatted_date}.xlsx`;
      setFileName(file_name);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, [allData])


  useEffect(() => {
    if(id) {
      setIsLoading(true);
      session.query(`compare/get/${id}`, {})
      .then((report) => {
        let check_data = report.comparison_report?.saved_selection_criteria;
        setAllData(report);
        if(check_data && check_data.report_name) {
          setData(check_data);
        } else {
          setHasBadData(true);
        }
      })
      .catch((error) => {
        console.log("Failed to get the report data.", error)
      })
      .finally(() => {
        setIsLoading(false);
      })
    } 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  if(hasBadData) {
    return (
      <div className="page admin-page">
        <div className="list-header sticky-page-header">
          <Link to="/compare-list">
            <Button type="button" className="new-button">
              <i className="bi bi-chevron-left"></i> Compare
            </Button>
          </Link>
          <h1>Compare Report Details</h1>
          <i className="spacer" />
          <Button className='new-button promote' onClick={handleDownload}>Download Report</Button>
        </div>
        <div className="roles-main margin-top-1">
          <div className="m-4 mt-5">
            <h5>Could Not Load the Report Details.</h5>
          </div>
        </div>
      </div>
    )
  }

  if(isLoading) {
    return (
      <div className="loader-container">
        <ProgressLoader />
      </div>
    );
  }

  return (
    <div className="page admin-page">
      <div className="list-header sticky-page-header">
        <Link to="/compare-list">
          <Button type="button" className="new-button">
            <i className="bi bi-chevron-left"></i> Compare
          </Button>
        </Link>
        <h1>Compare Report Details</h1>
        <i className="spacer" />
        <Button className='new-button promote' onClick={handleDownload}>Download Report</Button>
      </div>
      <div className="roles-main margin-top-1">
        <div className="m-4">
          <Card className="w-100 m-1">
            <CardHeader>                
              <div className="p-1">
                <span className="text-blue bold-600 font-size-9">NAME</span>: {data.report_name}
              </div>
            </CardHeader>
            <CardBody>
              <div className="p-2">
                <div className="mb-3">
                  <div className="text-blue bold-600 font-size-9">DESCRIPTION:</div> 
                  <div>{data.report_description}</div>
                </div>
                <div className="mb-3">
                  <div className="text-blue bold-600 font-size-9">CREATED BY:</div> 
                  <div>{data.created_by}</div>
                </div>
                <div className="mb-3">
                  <div className="text-blue bold-600 font-size-9">REPORT DETAILS:</div>
                  <div className="mb-3 mt-2">
                    <Card className="w-100 mt-1">
                      <CardHeader>Variables</CardHeader>
                      <CardBody>
                        <ul>
                          {(data.variables && data.variables.length) ? data.variables.map((item) => {
                            return (
                              <li key={item.label}>{item.label}</li>
                            )
                          }) : ""}
                        </ul>
                      </CardBody>
                    </Card>
                  </div>
                  <div className="mb-3">
                    <Card className="w-100 mt-1">
                      <CardHeader>Audiences</CardHeader>
                      <CardBody>
                        {data.groups.map((item, i) => {
                          return (
                            <div key={item.name + i} className="m-3 p-3 gray-border">
                              <div><span className="text-blue bold-600">Name</span>: {item.name}</div>
                              <div><span className="text-blue bold-600">Type</span>: {item.label}</div>
                              <div><span className="text-blue bold-600">Selections</span>:
                                <ul>
                                  {(item.values && item.values.length) ? item.values.map((val) => {
                                    return (
                                      <li key={val}>{val}</li>
                                    )
                                  }) : ""}
                                </ul>
                              </div>
                            </div>
                          )
                        })}
                      </CardBody>
                    </Card>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  )
}